if (!("withResolvers" in Promise && typeof Promise.withResolvers === "function")) {
    // @ts-expect-error
    Promise.withResolvers = function () {
        let resolve, reject;
        const promise = new this((res, rej) => {
            resolve = res;
            reject = rej;
        });

        return { promise, resolve, reject };
    }
}